import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import strings from "translate/language";
import { seo } from "utils/utils";
import Breadcrumb from "component/common/breadcrumb";

const BulkUploadImgCsv = () => {
  const navigate = useNavigate();
  const navigatpage = async (navname) => {
    navigate(navname);
  };
  useEffect(() => {
    seo({
      title: "Bulk Upload",
      metaDescription: "Bulk upload",
      canonicalLink: window.location.href,
    });
  }, []);
  return (
    <div className="page-body">
      <Breadcrumb
        title={strings.bulkUpload}
        url={"/visitor"}
        parentListing={strings.visitorList}
        titleactive={strings.bulkUpload}
        isBackBtn={true}
      />
      <div className="container-fluid">
        <div className="row ">
          <div className="col-sm-12 ">
            <div className="card">
              <div className="card-header pb-0">
                <h5>{strings.bulkUpload}</h5>
              </div>
              <form className="form theme-form">
                <div className="card-body">
                  <div className="row">
                    <div className="col-md-12">
                      <div className="card-footer text-center">
                        <button
                          className="btn btn-color"
                          type="button"
                          title="Click Here"
                          style={{ height: "100px", borderRadius: "12px" }}
                          onClick={() => navigatpage("/upload_image")}
                        >
                          {strings.imageUpload}
                        </button>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-12">
                      <div className="card-footer text-center">
                        <button
                          className="btn btn-color"
                          type="button"
                          title="Click Here"
                          style={{
                            height: "100px",
                            borderRadius: "12px",
                            width: "155px",
                          }}
                          onClick={() => navigatpage("/upload_csv")}
                        >
                          {strings.csvUpload}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default BulkUploadImgCsv;
